/* eslint-disable react/prop-types */
import React, { useEffect, useContext } from 'react';
import { useSelector, connect } from 'react-redux';

import API from 'constants/api';
import { getObject, setObjectParameters, resetState, massEditObjects } from 'actions/objectActions';
import { getObjectFields } from 'helpers/objectHelpers';
import LocaleContext from 'constants/localization';
import { setAlert } from 'actions/viewActions';
import { setAllowed } from 'actions/fieldActions';

import Loading from 'components/common/Loading';
import SaveButton from 'components/common/SaveButton';
import ArchivedObject from 'components/archived-object/ArchivedObject';
import MassEditField from './MassEditField';
import HelpContents from './HelpContents';

const MassEditView = ({ view, uri, removeProcedularUnitFields, massEditObjects, 
  getObject, setObjectParameters, resetState, setAlert, setAllowed }) => {
  const tabs = useSelector(state => state.object.tabs);
  const loading = useSelector(state => state.object.loading);
  const LS = useContext(LocaleContext);
  const saveDisabled = !tabs || tabs.length === 0;


  useEffect(() => {
	if(view === "Statement"){
		fetch(`${API.UI.MASS_EDIT_RESTRICTION}&view=${view}`,
  	    {
  	       method: 'GET'
  	    })
		.then(res => res.json())
		.then(json => {
			if (json.hasMassEditRestriction) {
				createNotification(LS.statement.massEditRestriction);
			}
		}).catch(e => {
			console.log(e);
		});
	}
    getObject(`${API.UI.MASS_EDIT}&view=${view}&removeProcedularUnitFields=${removeProcedularUnitFields}`
      , mapMassEditActions);
    setObjectParameters({ uri, view, removeProcedularUnitFields });
    return () => resetState();
  }, []);

  if (loading) {
    return <Loading />;
  }

  // Enable 'allowed' when updating a value automatically
  const mapMassEditActions = object => {
    for (let field of getObjectFields(object.tabs)) {
      const { setValue, addValue, createResource, 
        addResourceValue, predicate } = field;
      field.setValue = (index, value) => {
        setValue(index, value);
        setAllowed(predicate);
      };
      field.createResource = () => {
        createResource();
        setAllowed(predicate);
      };
      field.addResourceValue = (value) => {
        addResourceValue(value);
        setAllowed(predicate);
      };
      field.addValue = (value) => {
        addValue(value);
        setAllowed(predicate);
      };
      field.props.minOccurs = 0;
    }
  };

  return (
    <div id="MetaDataDisplayDiv" className="meta smallPane">
      <button type="button" onClick={() => setAlert({
        contents: () => <HelpContents lang={LS.getLanguage()} />,
        className: 'info-alert',
        draggable: true
      })} >
        {LS.info}
      </button>
      <SaveButton accessKey="s" disabled={saveDisabled} onSubmit={massEditObjects} />
      <ArchivedObject tabs={tabs} Field={MassEditField} />
      <SaveButton accessKey="s" disabled={saveDisabled} onSubmit={massEditObjects} />
    </div>
  ); 
};

export default connect(null, { massEditObjects, getObject, 
  setObjectParameters, resetState, setAlert, setAllowed })(MassEditView);
